import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.css';

import ContinueFooter from '../../components/ContinueFooter';

import FlatButton from 'material-ui/FlatButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import NavigationCheck from 'material-ui/svg-icons/navigation/check';
import ActionCheckCircle from 'material-ui/svg-icons/action/check-circle';

import questions from '../../config/questions';

const answerStyle = {
  textAlign: 'left',
  paddingTop: 8,
  paddingBottom: 8,
  height: 'auto',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const answerLabelStyle = {
  fontSize: 20,
  lineHeight: 1.5,
  display: 'block',
  textTransform: 'none',
};

class Quiz extends Component {

  static propTypes = {
    preTest: PropTypes.bool,
    onFinishQuiz: PropTypes.func.isRequired,
  };

  state = {
    done: false,
    answers: [],
    currentQuestionIndex: 0,
  };

  setAnswer = (key) => (e) => {
    const answers = this.state.answers;
    answers[this.state.currentQuestionIndex] = {
      answer: key,
      submitted: false,
    };

    this.setState({
      answers
    })
  };

  handleRetakePress = () => {
    this.setState({
      done: false,
      answers: [],
      currentQuestionIndex: 0,
    });
  };

  handleContinuePress = () => {
    const currentQuestionIndex = this.state.currentQuestionIndex;
    const currentAnswer = this.state.answers[currentQuestionIndex];

    if (currentAnswer && !currentAnswer.submitted) {
      const answers = this.state.answers;
      answers[this.state.currentQuestionIndex] = {
        ...currentAnswer,
        submitted: true,
      };

      this.setState({
        answers,
      })
    } else if (currentAnswer && currentAnswer.submitted && this.state.currentQuestionIndex < (questions.size - 1)) {
      this.setState({
        currentQuestionIndex: this.state.currentQuestionIndex + 1,
      });
    } else if (this.state.currentQuestionIndex === (questions.size - 1)) {
      this.setState({
        done: true,
      });
    }
  };

  handleBackPress = () => {
    this.setState({
      currentQuestionIndex: this.state.currentQuestionIndex - 1,
    });
  };

  handleFinishQuiz = () => {
    this.props.onFinishQuiz(this.state);
  };

  numberOfCorrectAnswers() {
    return parseInt(this.state.answers.filter(
      (answer, index) => answer.answer === questions.get(index).get('answer')
    ).length, 10);
  }

  renderAnswer = (answer, key) => {
    const currentQuestion = questions.get(this.state.currentQuestionIndex);
    const currentQuestionIndex = this.state.currentQuestionIndex;
    const currentAnswer = this.state.answers[currentQuestionIndex];
    const thisAnswerSelected = currentAnswer && currentAnswer.answer === key;
    const thisAnswerCorrect = currentQuestion.get('answer') === key;

    const iconStyle = { width: 32, height: 32 };

    let icon;
    if (currentAnswer && currentAnswer.submitted) {
      if (thisAnswerCorrect) {
        icon = <NavigationCheck color="green" style={iconStyle} />;
      } else if (thisAnswerSelected && !thisAnswerCorrect) {
        icon = <NavigationClose color="red" style={iconStyle} />;
      }
    }

    return (
      <FlatButton
        className="Quiz__answers__answer"
        fullWidth
        primary={currentAnswer && thisAnswerSelected}
        label={`${key}) ${answer}`}
        style={answerStyle}
        labelStyle={answerLabelStyle}
        labelPosition="before"
        icon={icon}
        onTouchTap={this.setAnswer(key)}
        disabled={currentAnswer && currentAnswer.submitted}
      />
    );
  };

  renderQuiz() {
    const currentQuestion = questions.get(this.state.currentQuestionIndex);
    const currentQuestionIndex = this.state.currentQuestionIndex;
    const currentAnswer = this.state.answers[currentQuestionIndex];

    return (
      <div className="Quiz">
        <header className="Quiz__header">
          <span className="Quiz__header__count">{this.state.currentQuestionIndex + 1} / {questions.size}</span>
          <h3 className="Quiz__header__title">{currentQuestion.get('question')}</h3>
        </header>
        <div className="Quiz__answers">
          {currentQuestion.get('answers').map(this.renderAnswer)}
        </div>
        <ContinueFooter
          showBack
          onBack={this.handleBackPress}
          disableBack={currentQuestionIndex === 0}
          continueLabel={currentAnswer && currentAnswer.submitted ? 'Continue' : 'Check'}
          disableContinue={!currentAnswer}
          onContinue={this.handleContinuePress}
        />
      </div>
    );
  };

  renderResults() {
    return (
      <div className="Results">
        <ActionCheckCircle color="green" style={{ height: 256, width: 256 }} />
        <h3 className="Results__message">You scored {this.numberOfCorrectAnswers()} / {questions.size}</h3>
        <ContinueFooter
          stacked
          showBack={this.props.preTest || this.numberOfCorrectAnswers() < questions.size}
          onBack={this.handleRetakePress}
          backLabel="Retake Quiz"
          continueLabel={this.props.preTest ? 'Continue to Video' : 'Congratulations! Redeem your certificate'}
          onContinue={this.handleFinishQuiz}
          showContinue={this.props.preTest}
          disableContinue={(!this.props.preTest && this.numberOfCorrectAnswers() < questions.size)}
        />
      </div>
    );
  }

  render() {
    return this.state.done ? this.renderResults() : this.renderQuiz();
  }
}

export default Quiz;



// WEBPACK FOOTER //
// ./src/containers/Quiz/index.js